import { render, staticRenderFns } from "./ModalAddProjectUser.vue?vue&type=template&id=47a1050f&"
import script from "./ModalAddProjectUser.vue?vue&type=script&lang=js&"
export * from "./ModalAddProjectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports